import {
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

export type DsStateBlockTone = 'default' | 'error' | 'empty';

@Component({
  selector: 'ds-state-block',
  templateUrl: 'ds-state-block.component.html',
  styleUrls: ['ds-state-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DsStateBlockComponent {
  @Input() message = '';
  @Input() tone: DsStateBlockTone = 'default';
  @Input() bordered = true;
}
